import { render, staticRenderFns } from "./CharCount.vue?vue&type=template&id=2fc87f91&scoped=true"
import script from "./CharCount.vue?vue&type=script&lang=js"
export * from "./CharCount.vue?vue&type=script&lang=js"
import style0 from "./CharCount.vue?vue&type=style&index=0&id=2fc87f91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc87f91",
  null
  
)

export default component.exports